import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-access-management',
  templateUrl: './access-management.component.html',
  styleUrls: ['./access-management.component.scss']
})
export class AccessManagementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
